<template>
    <div v-if="tenant && user" class="order-layout">

        <!-- Order App Bar -->
        <order-app-bar />

        <!-- Order Navigation Drawer -->
        <order-navigation-drawer />
        
        <!-- Order Main Content -->
        <v-main class="no-transition">
            <router-transition>
                <router-view />
            </router-transition>
        </v-main>

        <!-- Order Footer -->
        <order-footer />

    </div>
</template>

<script>
import RouterTransition from '@/router/RouterTransition';
import OrderAppBar from '@/views/aria/order/OrderAppBar';
import OrderNavigationDrawer from '@/views/aria/order/OrderNavigationDrawer';
import OrderFooter from '@/views/aria/order/OrderFooter';

export default {
    name: 'OrderLayout',

    components: {
        RouterTransition,
        OrderAppBar,
        OrderNavigationDrawer,
        OrderFooter,
    },

    data() {
        return {
        };
    },
};
</script>

<style scoped lang="scss">
.order-layout {
    height: 100%;

    -webkit-user-select: none;
    -webkit-app-region: drag;

    .v-main {
        height: 100%;
    }
}
</style>
